import React from "react";
import { useAuth } from "../auth/hooks/useAuth";
import { UserRole } from "../user/enums/UserRole";
import BillingPage from "./pages/BillingPage";

const BillingPageWrapper = () => {
  let schoolId: string | undefined;
  let agentId: string | undefined;
  let parentId: string | undefined;
  let studentId: string | undefined;

  const {
    user,
    profile: { data: { data: profile = null } = {} },
  } = useAuth();

  switch (user.role) {
    case UserRole.School: {
      schoolId = profile?.school.id;
      break;
    }
    case UserRole.Agent: {
      agentId = user.id;
      break;
    }
    case UserRole.Parent: {
      parentId = user.id;
      break;
    }
    case UserRole.Student: {
      studentId = user.id;
      break;
    }
  }

  return (
    <BillingPage
      showFilter={!studentId}
      schoolId={schoolId}
      agentId={agentId}
      parentId={parentId}
      studentId={studentId}
    />
  );
};

export default BillingPageWrapper;
